var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-cog"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 15.8334H4.16667C3.72464 15.8334 3.30072 15.6578 2.98816 15.3453C2.67559 15.0327 2.5 14.6088 2.5 14.1667V5.83341M2.5 5.83341C2.5 5.39139 2.67559 4.96746 2.98816 4.6549C3.30072 4.34234 3.72464 4.16675 4.16667 4.16675H15.8333C16.2754 4.16675 16.6993 4.34234 17.0118 4.6549C17.3244 4.96746 17.5 5.39139 17.5 5.83341M2.5 5.83341L10 10.8334L17.5 5.83341M17.5 5.83341V10.0001M15.8342 17.5001C15.3921 17.5001 14.9682 17.3245 14.6557 17.0119C14.3431 16.6994 14.1675 16.2754 14.1675 15.8334C14.1675 15.3914 14.3431 14.9675 14.6557 14.6549C14.9682 14.3423 15.3921 14.1667 15.8342 14.1667M15.8342 17.5001C16.2762 17.5001 16.7001 17.3245 17.0127 17.0119C17.3252 16.6994 17.5008 16.2754 17.5008 15.8334C17.5008 15.3914 17.3252 14.9675 17.0127 14.6549C16.7001 14.3423 16.2762 14.1667 15.8342 14.1667M15.8342 17.5001V18.7501M15.8342 14.1667V12.9167M18.36 14.3751L17.2775 15.0001M14.3917 16.6667L13.3083 17.2917M13.3083 14.3751L14.3917 15.0001M17.2775 16.6667L18.3608 17.2917",
    stroke: "#3A3D40",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCog);
export default __webpack_public_path__ + "static/media/mail-cog.006b81c3eb345881a84a39cac9b862e7.svg";
export { ForwardRef as ReactComponent };